module.exports = __webpack_public_path__ + "img/search-no@2x.91e52507.png";